module.exports = __webpack_public_path__ + "img/Loading_r_22.60df2587.png";